import { render, staticRenderFns } from "./OfertaTCCA.vue?vue&type=template&id=6a4e3122&scoped=true"
import script from "./OfertaTCCA.vue?vue&type=script&lang=js"
export * from "./OfertaTCCA.vue?vue&type=script&lang=js"
import style0 from "./OfertaTCCA.vue?vue&type=style&index=0&id=6a4e3122&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a4e3122",
  null
  
)

export default component.exports